import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { App, type URLOpenListenerEvent } from "@capacitor/app";
import { logger } from "@/lib/logger";

/**
 * Listen for deep links (Universal Links / App Links) on native platforms
 * and navigate to the corresponding route in React Router.
 */
export function useDeepLinks() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const handleAppUrlOpen = (event: URLOpenListenerEvent) => {
      try {
        const url = new URL(event.url);
        const path = url.pathname + url.search + url.hash;
        logger.info("deep-links", `Deep link received: ${path}`);
        if (path) {
          navigate(path);
        }
      } catch (e) {
        logger.error("deep-links", "Failed to parse deep link:", e);
      }
    };

    App.addListener("appUrlOpen", handleAppUrlOpen);

    return () => {
      App.removeAllListeners();
    };
  }, [navigate]);
}
